import delegate from 'delegate';
import { str2json } from '@src/utils';

export default {
  init: (app) => {
    const ctx = app;

    delegate(
      document.body,
      '.has-link',
      'click',
      (e) => {
        // If already a link bailout
        if (e.target.tagName == 'A' || e.target.tagName == 'button' || e.target.tagName == 'BUTTON') {
          return;
        }
        const link = e.delegateTarget.querySelector('a');
        if (link && link.href) {
          e.preventDefault();
          if (link.target === '_blank') {
            window.open(link.href, '_blank');
          } else {
            window.location.href = link.href;
          }
        }
      },
      false
    );

    delegate(
      document.body,
      '[data-action]',
      'click',
      (e) => {
        e.preventDefault();
        const evData = str2json(e.delegateTarget.dataset.action);
        ctx.emit(evData.type, { identifier: evData.target, action: evData.action });
      },
      false
    );

    // delegate(
    //   document.body,
    //   '[data-action]',
    //   'keyup',
    //   (e) => {
    //     if (e.keyCode === 13) {
    //       e.preventDefault();
    //       // const evData = str2json(e.delegateTarget.dataset.action);
    //       // ctx.emit(evData.type, { identifier: evData.target, action: evData.action });
    //     }
    //   },
    //   false
    // );

    // document.querySelectorAll('[data-action]').forEach((item) => {
    //   item.addEventListener('keydown', (e) => {
    //     if (e.keyCode === 13) {
    //       const evData = str2json(item.dataset.action);
    //       ctx.emit(evData.type, { identifier: evData.target, action: evData.action });
    //     }
    //   });
    // });

    if (!navigator.cookieEnabled) {
      document.body.classList.add('cookies-not-supported');
    }
    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  },
};
